import React, { useEffect, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import styles from './ListOfLevels.module.scss'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import { Level } from './Level/Level'
import Loader from 'components/UI/Loader/Loader'
import Pagination from 'components/UI/Pagination/Pagination'
import AddLevel from './modals/AddLevel'

const initPagination = {
  page: 1,
  limit: 10,
}

export const ListOfLevels = ({ translate }) => {
  const [levels, setLevels] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const fetchLevels = () => {
    superAxiosRequest({
      method: 'get',
      link: 'integration/teaching_levels',
      crm: true,
      params: {
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setLevels(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    setLoading(true)
    fetchLevels()
  }, [pagination])

  const addLevel = () => {
    const ms = {
      modalBodyComponent: () => <AddLevel />,
      button: 'Save',
      link: 'integration/teaching_levels',
      title: 'Добавить уровень',
      isResponsive: true,
      crm: true,
      onSubmitSuccess: () => {
        fetchLevels()
      },
      valid: {
        name: 'required',
      },
    }

    asideModalStore.activity(ms, {})
  }

  const editLevel = (level) => {
    const ms = {
      modalBodyComponent: () => <AddLevel />,
      button: 'Сохранить',
      link: `integration/teaching_levels/${level?.id}`,
      title: 'Редактировать уровень',
      isCenter: true,
      is_put: true,
      crm: true,
      onSubmitSuccess: fetchLevels,
      valid: {
        name: 'required',
      },
    }
    asideModalStore.activity(ms, level)
  }

  const deleteLevel = (levelId) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the level?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        const apiConf = {
          method: 'delete',
          link: `integration/teaching_levels/${levelId}`,
          crm: true,
        }
        superAxiosRequest(apiConf).then(() => {
          setLevels((prevState) => ({
            ...prevState,
            result: prevState.result.filter((el) => el?.id !== levelId),
          }))
        })
      }
    })
  }

  const action = (actionType, e, items) => {
    const actions = new Map([
      ['edit_level', () => editLevel(items)],
      ['delete_level', () => deleteLevel(items.id)],
    ])
    return actions.get(actionType)?.()
  }

  const menu = [
    { name: translate.edit, action: 'edit_level' },
    { name: translate.delete, action: 'delete_level' },
  ]

  return (
    <div className={styles.reasonsContainer}>
      <div className={styles.header}>
        <PageHeader title={translate.list_of_levels} />
        <div className={styles.settingsLocalization__box}>
          <HeaderAddButton title={translate.add_level} onClick={addLevel} />
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <>
          {levels?.result?.length === 0 ? (
            <div className={styles.noReasons}>There are no added cities</div>
          ) : (
            levels?.result?.map((level, index) => (
              <Level
                key={level.id}
                level={level}
                action={action}
                index={index}
                menu={menu}
              />
            ))
          )}
        </>
      )}
      <div className={styles.pagination}>
        {levels?._meta.count_items > 5 && (
          <Pagination
            limit={pagination.limit}
            count={levels._meta.count_items || 0}
            page={pagination.page}
            onChange={(page) => setPagination({ ...pagination, page })}
            onChangePerPage={(limit) => {
              setPagination({ page: 1, limit })
            }}
          />
        )}
      </div>
    </div>
  )
}
